// @owners { team: patient-health }
import { LoadingEmptyState, XlPadding } from '@alto/design-system';
import { Experimentation } from '@alto/experimentation';
import { SupportPage } from '@alto/features';
import React from 'react';
import { LandingPage } from '~web/features/alto-assistant/components/LandingPage';

export const LandingPageWrapper = () => {
  const { value: showNewSupportPage, isLoading } = Experimentation.useFeatureFlag('altoassistant_support_page');

  if (isLoading) {
    return (
      <XlPadding>
        <LoadingEmptyState />
      </XlPadding>
    );
  }
  return showNewSupportPage ? <SupportPage /> : <LandingPage />;
};
